import { createReducer, field } from "redux/shelf";
import { pick } from 'ramda';
import { search, get, put } from "redux/shelf/api";
import session from 'lib/session';

export const actions = {
  fetch: get`color-palette/${session.getMerchant}`(),
  update: put`color-palette/${session.getMerchant}`(),
  getFilters: search.post`/facet/values`(pick(['facets']))
}

export const reducer = createReducer(actions);
